// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LnpZg{display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;min-height:100vh;padding:32px;gap:16px}.ckep3{margin-bottom:16px}.r5KSv{display:flex;justify-content:space-between;width:100%;max-width:360px;gap:16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen": `LnpZg`,
	"title": `ckep3`,
	"row": `r5KSv`
};
export default ___CSS_LOADER_EXPORT___;
